<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Exon Info</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter Gene Name for Info.</div>
                    <mat-icon matTooltip="Enter your Protein substitutions in the format BRAF:V600E. For multiple conversion separate your inputs with a comma. E.g. 'TP53:R282W,BRAF:V600E' or click 'Load Example' to get a basic example." 
                    matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter HUGO Gene names, e.g. 'BRAF' or click 'Load Example'"></textarea>
            </div>
            <div>
                <div>
                    <span>Reference Genome</span>
                    <div>
                        <div>
                            <input type="radio" id="hg19" name="referenceGenome" value="hg19"
                                formControlName="referenceGenome" />
                            <label for="hg19">HG19</label>
                        </div>
                        <div>
                            <input type="radio" id="hg38" name="referenceGenome" value="hg38"
                                formControlName="referenceGenome" />
                            <label for="hg38">HG38</label>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200">
            <div class="card" *ngFor="let exon of element['exons']" style="margin:5px">
                <li>Exon #: {{exon['exon']}}</li>
                <li>Chromosome: {{exon['chr']}}</li>
                <li>Strand: {{exon['strand']}}</li>
                <li>Transcript: {{exon['transcript']}}</li>

                <li>Chromosom Start Position: {{exon['alt_start_i']}}</li>
                <li>Chromosom End Position: {{exon['alt_end_i']}}</li>

                <li>CDS Start Position: {{exon['cds_start']}}</li>
                <li>CDS End Position: {{exon['cds_end']}}</li>
                
                <li>Exon Start Position: {{exon['tx_start_i']}}</li>
                <li>Exon End Position: {{exon['tx_end_i']}}</li>
                <li>Exon Length: {{exon['cds_length']}}</li>
            </div>

            <!-- <li>Chromosome: {{element['dna_sequence_full']}}</li>
            <li>Possible Exchanges: {{element['protein_sequence_one_letter']}}</li>
            <li>Used Transcript: {{element['protein_sequence_three_letter']}}</li> -->
        </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
        </ul>
    </div>
</div>
